module.exports = __webpack_public_path__ + "img/4.49446308.gif";